import { useStockByDistance } from '@/cataloguePages/productPageWithVariants/helpers';
import { useState } from 'react';
import { Button, Sticker } from '@fagmobler/ui';
import StoreStock from '@/cataloguePages/productPageWithVariants/components/StoreStock';
import { useOpeningHours } from '@/components/store';
import { MinusIcon, PlusIcon } from '@heroicons/react/24/solid';
import ProductStatus from '@/cataloguePages/productPageWithVariants/components/ProductStatus';
import { getStorePath } from '@/lib/omnium/getStoreUrl';
import Link from 'next/link';

type StoreProps = {
  store: ReturnType<typeof useStockByDistance>[0];
  isCurrentStore: boolean;
};

export function Store({ store, isCurrentStore }: StoreProps) {
  const [isOpen, setIsOpen] = useState(false);
  const openingHours = useOpeningHours(store, true);
  const storePath = getStorePath(store);

  return (
    <div className="w-full flex flex-col">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex flex-col gap-0.5"
      >
        <div className="flex justify-between gap-2 mb-3">
          <div className="flex flex-col gap-1">
            {isCurrentStore && (
              <Sticker size="xs" variant="neutralDark" className="!mb-0">
                MIN BUTIKK
              </Sticker>
            )}
            <span className="cap-sm font-bold">{store.name}</span>
          </div>
          {isOpen ? (
            <MinusIcon className="size-5 font-bold" />
          ) : (
            <PlusIcon className="size-5 font-bold" />
          )}
        </div>

        <StoreStock
          key={store.id}
          storeName={store.name ?? null}
          storeStock={store.stock}
          showStoreName={false}
        />
        {store.stock && store.stock.display > 0 && (
          <ProductStatus badgeVariant="eye" badgeText="Utstilt i butikk" />
        )}
      </button>
      {isOpen && (
        <div className="flex flex-col gap-1 items-start mt-3">
          <span className="body-xs">Åpningstider:</span>
          <div className="grid grid-cols-[max-content_1fr] gap-2 mb-3">
            {Object.entries(openingHours).map(([key, value]) => (
              <>
                <span className="body-xs text-neutral-70">{key}</span>
                <span className="body-xs">{value}</span>
              </>
            ))}
          </div>
          {storePath && (
            <Link href={storePath}>
              <Button variant="outline">Vis butikkside</Button>
            </Link>
          )}
        </div>
      )}
    </div>
  );
}
